import FullCalendar from '@fullcalendar/react';
import React, { useEffect, useState } from 'react';
import { Button, Grid, Tooltip, Typography } from '@material-ui/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import { withStyles, makeStyles } from '@material-ui/styles';
import timeGridPlugin from '@fullcalendar/timegrid';
import KenLoader from '../../../../Components/KenLoader/index';
import './styles.scss';
import {
  CALENDAR_TYPES,
  RESOURCE_TYPES,
} from '../../../../Utils/helper/schedulerHelper';
import {
  getFacilityBookedSlots,
  getFacultyBookingsData,
  getSessionData,
  getCampusHolidaysData,
  getPlannedData,
  getFacultyAndFacilty,
  getCourseVersionsByFacility,
} from '../../../../Utils/apiServices';
import KenGrid from '../../../../global_components/KenGrid';

const useStyles = makeStyles((theme) => ({
  sideTable: {
    position: 'relative',
    top: 8,
  },
  activeBtn: {
    background: '#1A251A',
    color: '#fff',
    borderRadius: 0,
    '&:hover': {
      background: '#1A251A',
      color: '#fff',
    },
  },
  defaultBtn: {
    background: '#2C3E50',
    color: '#fff',
    borderRadius: 0,
    '&:hover': {
      background: '#2C3E50',
      color: '#fff',
    },
  },
  activeName: {
    fontWeight: 600,
    color: '#272727',
  },
  regularName: {
    fontWeight: 400,
    color: '#000',
  },
}));
export default function ResourceCalendar(props) {
  const {
    id,
    name,
    resourceType,
    calendarType,
    currentSelected,
    selectedRowData,
    setResourceType,
    setDisableBtn,
    setFacilitySelected,
    activitiesData,
  } = props;
  console.log('selectedRowData', selectedRowData);
  const classes = useStyles();
  const [events, setEvents] = React.useState([]);
  const [dataId, setDataId] = useState(id);
  const [tableData, setTableData] = React.useState([]);
  const [facilityData, setFacilityData] = React.useState([]);
  const [enableResourceType, setEnableResourceType] = useState(true);
  const [loading, setLoading] = React.useState(false);
  const [holidayRes, setHolidayRes] = React.useState([]);
  const [sessionRes, setSessionRes] = React.useState([]);
  const [plannedRes, setPlannedRes] = React.useState([]);
  const [serviceTabs] = useState([
    { index: 1, title: 'Faculty', value: 'faculty' },
    { index: 2, title: 'Facility', value: 'facility' },
  ]);
  const [itemIndex, setItemIndex] = React.useState(2);
  const [selectedFacility, setSelectedFacility] = useState(
    selectedRowData?.facility
  );
  const [highlightIndex, setHighlightIndex] = React.useState('');
  const [currentTabSelected, setCurrentSelected] = React.useState(resourceType);
  const facultyHead = [
    {
      Header: 'Faculty',
      accessor: 'title',
      disableGlobalFilter: false,
      Cell: ({ value, row }) => {
        const title = row?.original?.title;
        const facultyId = row?.original?.value;
        return (
          <p
            className={
              highlightIndex === facultyId
                ? classes.activeName
                : classes.regularName
            }
            style={{ cursor: 'pointer' }}
            onClick={() => {
              handleFacultyCheck(facultyId);
            }}
          >
            {title}
          </p>
        );
      },
    },
  ];
  const facilityHead = [
    {
      Header: 'Facility',
      accessor: 'facilityName',
      disableGlobalFilter: false,
      Cell: ({ value, row }) => {
        const title = row?.original?.facilityName;
        const facilityId = row?.original?.id;
        return (
          <p
            className={
              highlightIndex === facilityId
                ? classes.activeName
                : classes.regularName
            }
            style={{ cursor: 'pointer' }}
            onClick={() => {
              handleFacilityCheck(row?.original);
            }}
          >
            {title}
          </p>
        );
      },
    },
    {
      Header: 'Capacity',
      accessor: 'facilityCapacity',
      disableGlobalFilter: false,
    },
    {
      Header: 'Type',
      accessor: 'facilityType',
      disableGlobalFilter: false,
    },
    {
      id: 'campus',
      Header: 'Campus',
      accessor: (d) => (
        <>
          {d.campus ? (
            <Typography style={{ fontSize: '12px', textAlign: 'center' }}>
              {d.campus}
            </Typography>
          ) : (
            <Typography>-</Typography>
          )}
        </>
      ),
      disableGlobalFilter: false,
    },
  ];
  const useItemStyles = makeStyles((theme) => ({
    root: {
      '& > .MuiTreeItem-content': {
        height: '35px',
      },
      '& > .MuiTreeItem-content > .MuiTreeItem-label': {
        display: 'flex',
        alignItems: 'center',
        padding: '4px 0',
        background: 'transparent !important',
        pointerEvents: 'none',
        fontSize: '12px',
        lineHeight: '12px',
        padding: '0 15px 15px',
      },
      '& > .MuiTreeItem-content  > .MuiTreeItem-label::before': {
        content: "''",
        display: 'inline-block',
        minWidth: 15,
        minHeight: 15,
        marginRight: 8,
        border: '1px solid #ccc',
        background: 'white',
      },
    },
    iconContainer: {
      marginRight: 3,
      marginLeft: 0,
      '& > svg': {
        '&:hover': {
          opacity: 0.6,
        },
      },
    },
    label: {
      padding: 0,
    },
    selected: {
      '& > .MuiTreeItem-content  > .MuiTreeItem-label::before': {
        background: theme.palette.primary.main,
        // content: '\f095',
        border: '1px solid #ccc',
        // fontFamily: 'Font Awesome 5 Free',
      },
    },
    tooltipTable: {
      minWidth: ' 250px',
      maxWidth: '100%',
      padding: '30px',
      borderCollapse: ' collapse',
      background: '#ffffff',
      padding: '10px',
    },
    tooltipTable_Tr: {
      height: '25px',
      color: '#7A869A',
      fontSize: '12px',
      background: '#fff',
    },
    tooltipTable_td: {
      height: '25px',
      paddingLeft: '10px',
      color: '#7A869A',
      // background: '#f4f6fc',
      borderBottom: '1px solid rgba(224, 224, 224, 1)',
      // borderLeft: '1px solid #303030',
      fontSize: '12px',
    },
    tooltipTable_th: {
      height: '25px',
      paddingLeft: '10px',
      color: 'rgb(9, 38, 130)',
      background: '#ffffff',
      borderBottom: '1px solid rgba(224, 224, 224, 1)',
    },
  }));
  const BlueOnGreenTooltip = withStyles({
    tooltip: {
      color: 'lightblue',
      // backgroundColor: "green",
      // padding: 0,
      border: '1px solid #fff',
      borderRadius: '4px',
      background: '#ffffff',
      boxShadow: '-2px 1px 8px 1px #737f8d',
    },
  })(Tooltip);
  const classesItem = useItemStyles();
  //   retrive events/bookings
  useEffect(() => {
    const getEventList = async () => {
      if (dataId != undefined) {
        setLoading(true);
        let querry = ``;
        if (!Object.values(RESOURCE_TYPES).includes(currentTabSelected)) {
          // TODO: dispaly error as resourcetype is not valid
          return;
        }
        let payload =
          currentTabSelected === RESOURCE_TYPES.facility
            ? { facultyId: dataId }
            : { facilityId: dataId };
        const sessionData =
          calendarType === CALENDAR_TYPES.SESSIONS
            ? await getSessionData(payload)
            : calendarType === CALENDAR_TYPES.ACADEMIC_PLANNER
            ? currentTabSelected === RESOURCE_TYPES.FACULTY
              ? await getFacultyBookingsData({ facultyId: dataId })
              : currentTabSelected === RESOURCE_TYPES.FACILITY
              ? await getFacilityBookedSlots({ facilityId: dataId })
              : null
            : null;
        const holidayData = await getCampusHolidaysData(querry);
        let querry2 = `facilityId=${dataId}`;
        const plannedData = await getPlannedData(querry2);
        let holidayListData;
        let sessionListData;
        let plannedListData;
        let activitiesListData = [];
        let bookedFacilityData = [];
        if (holidayData.length > 0) {
          holidayListData = holidayData?.map((e) => ({
            ...e,
            title: `${e?.holidayName} - ${e?.holidayType}`,
            start: e?.startDate,
            end: e?.endDate,
            editable: false,
            allDay: true,
            display: 'background',
            backgroundColor: 'rgb(127, 183, 126, 1)',
            class: 'holiday-listing',
          }));
        }
        console.log('holidayListData', holidayListData);
        setHolidayRes(holidayListData);
        if (Object.values(sessionData).length > 0) {
          sessionListData = Object.values(sessionData).map((s) => ({
            ...s,
            title: s.activityType,
            start: s.startDate,
            end: s.endDate,
          }));
        }
        console.log('sessionListData', sessionListData);
        setSessionRes(sessionListData);
        if (Object.values(plannedData).length > 0) {
          if (!plannedData.message) {
            Object.values(plannedData)?.map((el) => {
              return (plannedListData = el.map((el2) => ({
                ...el2,
                title: el2.activityType,
                start: `${el2.startDate}`,
                end: `${el2.endDate}`,
              })));
            });
          } else {
            plannedListData = [];
          }
        }
        setPlannedRes(plannedListData);
        if (activitiesData.length > 0) {
          activitiesListData = activitiesData.map((el3) => ({
            ...el3,
            title: el3?.subjectName,
            start: `${el3.startDate}`,
            end: `${el3.endDate}`,
          }));
          console.log('activitiesData', activitiesListData);
        }
        const bookedFacility = await getCourseVersionsByFacility(querry2);
        if (bookedFacility.length > 0) {
          bookedFacilityData = bookedFacility.map((el4) => ({
            ...el4,
            title: el4?.courseName,
            start: `${el4?.startDate}`,
            end: `${el4?.EndDate}`,
            color: 'white',
            textColor: '#272727',
          }));
        }
        setSessionRes([...sessionListData, ...bookedFacilityData]);
        console.log('bookedFacility', bookedFacility);
        setEvents([
          ...sessionListData,
          ...holidayListData,
          ...activitiesListData,
          ...bookedFacilityData,
        ]);
        setLoading(false);
      }
    };
    getEventList();
  }, [dataId, currentTabSelected]);

  useEffect(() => {
    if (
      holidayRes.length > 0 ||
      sessionRes.length > 0 ||
      plannedRes.length > 0
    ) {
      if (currentSelected === 'Actual') {
        setEvents([...sessionRes, ...holidayRes]);
      } else if (currentSelected === 'Planned') {
        setEvents([...plannedRes, ...holidayRes]);
      } else if (currentSelected === 'Both') {
        setEvents([...plannedRes, ...sessionRes, ...holidayRes]);
      }
    }
  }, [currentSelected]);

  const currentDataRequirement = (item) => {
    setItemIndex(item.index);
    let title = String(item.title).toLowerCase();
    setCurrentSelected(title);
    setDisableBtn(true);
    setResourceType(title);
  };

  useEffect(() => {
    setLoading(true);
    const getFacilty = async () => {
      const faciltiyAndFacultyData = await getFacultyAndFacilty();
      const facilityData = faciltiyAndFacultyData?.Facility;
      setFacilityData(facilityData);
      setLoading(false);
    };
    getFacilty();
  }, []);
  const handleFacilityCheck = (data) => {
    setDataId(data.id);
    setDisableBtn(false);
    setHighlightIndex(data.id);
    setFacilitySelected(data);
  };
  const handleFacultyCheck = (id) => {
    setDataId(id);
    setHighlightIndex(id);
  };

  useEffect(() => {
    if (
      selectedRowData != undefined &&
      Object.values(selectedRowData).length > 0
    ) {
      setDataId(undefined);
      setEnableResourceType(false);
      if (currentTabSelected !== 'faculty') {
        let facilitiesData = Object.values(facilityData);
        setHighlightIndex(facilitiesData?.[0]?.id);
        setDataId(facilitiesData?.[0]?.id);
        setFacilitySelected(facilitiesData[0]);
        setTableData(facilitiesData);
      } else {
        let tableData = selectedRowData?.facultyList;
        setSelectedFacility(selectedRowData?.facility);
        setTableData(tableData);
      }
    }
  }, [currentTabSelected, facilityData, selectedRowData]);

  function renderEventContent(eventInfo) {
    console.log('renderEventContent:      ==', eventInfo.event);
    const toopTiptext = (
      <table className={classesItem.tooltipTable}>
        <tr className={classesItem.tooltipTable_Tr}>
          <th className={classesItem.tooltipTable_th}>Activity Information</th>
          <th className={classesItem.tooltipTable_th}></th>
        </tr>
        <tr>
          <th className={classesItem.tooltipTable_th}>Subject</th>
          <td className={classesItem.tooltipTable_td}>
            {eventInfo.event.title}
          </td>
        </tr>{' '}
        <tr>
          <th className={classesItem.tooltipTable_th}>Faculty</th>
          <td className={classesItem.tooltipTable_td}>
            {eventInfo.event.extendedProps.faculty1Name}
          </td>
        </tr>{' '}
        <tr>
          <th className={classesItem.tooltipTable_th}>Facility</th>
          <td className={classesItem.tooltipTable_td}>
            {eventInfo.event.extendedProps.facilityName}
          </td>
        </tr>
      </table>
    );
    return (
      <div>
        <>
          <BlueOnGreenTooltip title={toopTiptext} placement="bottom">
            <div>
              <i className="text-change"> {eventInfo.event.title}</i>
            </div>
          </BlueOnGreenTooltip>
        </>
      </div>
    );
  }
  useEffect(() => {
    if (tableData.length > 0) {
      const selectedData = tableData;
      selectedData.map((item) => {
        if (item?.facilityName === selectedFacility) {
          return handleFacilityCheck(item);
        }
      });
    }
  }, [tableData, selectedFacility]);
  return (
    <div className="full-calendar-div" style={{ width: '100%' }}>
      {loading && <KenLoader />}
      <Grid container xs={12}>
        {!enableResourceType ? (
          <Grid item xs={4} className={classes.sideTable}>
            {serviceTabs?.map((item) => {
              return (
                <Button
                  name={item.title}
                  className={
                    itemIndex === item.index
                      ? classes.activeBtn
                      : classes.defaultBtn
                  }
                  onClick={(e) => {
                    currentDataRequirement(item);
                  }}
                >
                  {item.title}
                </Button>
              );
            })}
            <div className="facilityFaculty-table">
              <KenGrid
                columns={
                  currentTabSelected === 'faculty' ? facultyHead : facilityHead
                }
                data={tableData}
                pagination={{ disabled: true }}
                toolbarDisabled={true}
              />
            </div>
          </Grid>
        ) : null}
        <Grid
          item
          xs={!enableResourceType ? 8 : 12}
          className="resource-fc-grid"
        >
          <FullCalendar
            headerToolbar={{
              left: 'prev,date,next today',
              center: 'title myCustomButton myCustomButton1',
              right: 'timeGridWeek,dayGridMonth',
            }}
            customButtons={{
              myCustomButton: { text: 'Actual' },
              myCustomButton1: { text: 'Planned' },
            }}
            initialDate={selectedRowData?.startDate}
            plugins={[dayGridPlugin, timeGridPlugin]}
            events={events}
            eventContent={renderEventContent}
          />
        </Grid>
      </Grid>
    </div>
  );
}
